import { Entity } from '@shared/constants/entity';

export default class TimedMapMarkerUtils {
  static getEntityIconByTimeDifference(
    minutes: number,
    entityType: 'Vehicle' | 'Asset'
  ): string {
    const folderName = entityType === Entity.Vehicle ? 'cars' : 'vt-assets';

    const min = Math.abs(minutes);
    if (min < 10) {
      return `./assets/${folderName}/green.svg`;
    } else if (min >= 10 && min < 60) {
      return `./assets/${folderName}/blue.svg`;
    } else if (min >= 60 && min < 24 * 60) {
      return `./assets/${folderName}/orange.svg`;
    } else if (min >= 24 * 60 && min < 48 * 60) {
      return `./assets/${folderName}/red.svg`;
    } else if (min >= 48 * 60) {
      return `./assets/${folderName}/black.svg`;
    }
    return `./assets/${folderName}/black.svg`;
  }
}
